import React, {memo, useEffect, useState} from 'react';
import classNames from 'classnames';
import placeholder from '~/assets/images/noimage-placeholder.svg';
import {UiBox, UiIcon} from '~/components/elements';
import {AiOutlineClose} from 'react-icons/all';
import {Image, ImageProps} from '@chakra-ui/react';
import {icons, IconTypes} from '~/components/elements/icons';
export interface UiImageProps extends ImageProps {
  url?: string;
  inline?: boolean;
  onClose?: (arg0: any) => any;
  containerClasses?: string;
  type?: string;
  name?: string;
}

export const UiImage = memo(function AppImage({
  url,
  containerClasses,
  onClose,
  inline,
  type,
  name,
  ...rest
}: UiImageProps) {
  const [imageSrc, setImageSrc] = useState(url || placeholder);

  useEffect(() => {
    setImageSrc(url || placeholder);
  }, [url]);

  return (
    <div className={classNames(containerClasses, {inline})}>
      {!!onClose && imageSrc !== placeholder && (
        <UiBox size="mini" onClick={onClose} cursor="pointer" display="flex" justifyContent="flex-end">
          <UiIcon as={AiOutlineClose} color="red" />
        </UiBox>
      )}
      <Image
        src={type === 'icon' && Object.keys(icons).includes(name as IconTypes) ? icons[name as IconTypes] : imageSrc}
        onError={() => setImageSrc(placeholder)}
        className={classNames({inline})}
        {...rest}
      />
      {/* Work in progress */}
    </div>
  );
});
